import { useEffect, useState } from 'react';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router';
import { api, Spinner } from '@karozik/ui';
import { Login } from './pages/Login';
import { Events } from './pages/Events';
import { EventPage } from './pages/EventPage';
import { Player } from './player/Player';

function RequireAdmin() {
  const [state, setState] = useState<'loading' | 'in' | 'out'>('loading');
  useEffect(() => {
    api<{ authenticated: boolean }>('/api/admin/me')
      .then((r) => setState(r.authenticated ? 'in' : 'out'))
      .catch(() => setState('out'));
  }, []);
  if (state === 'loading') {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (state === 'out') return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  return <Outlet />;
}

const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <RequireAdmin />,
    children: [
      { path: '/', element: <Events /> },
      { path: '/events/:id/:tab?', element: <EventPage /> },
      { path: '/player/:id', element: <Player /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
